(function() {
  'use strict';

  var PLACEHOLDER_TEXT = 'Please select an option';
  var BUNDLE_CONTAINER_ID = 'simple-bundles-io-options';

  var addToCartButton = null;
  var isManualSubmit = false;
  var bundleReady = false;

  // ============================================
  // UTILITY
  // ============================================

  function getBundleContainer() {
    return document.getElementById(BUNDLE_CONTAINER_ID);
  }

  function getBundleSelects() {
    var container = getBundleContainer();
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('select'));
  }

  // Parse option text — handles two formats from Simple Bundles:
  //   Format A (5ml bundles):  "ProductName - VariantSize"  e.g. "Amsterdam - 5ml"
  //   Format B (100ml bundles): "VendorText"                e.g. "Alien Inspired"
  // Detect by checking if splitting on " - " gives a known product name in the lookup.
  function parseOption(optionText) {
    var text = optionText.trim();
    var parts = text.split(' - ');
    var name = '';
    var inspiredBy = '';
    var image = '';

    var vendorLookup = window.bundleVendorLookup || {};
    var imageLookup = window.bundleImageLookup || {};

    if (parts.length >= 2 && vendorLookup[parts[0].trim()]) {
      // Format A: "ProductName - VariantSize" — product name is in the lookup
      name = parts[0].trim();
    } else {
      // Format B: full string is the option text (e.g. "Alien Inspired")
      // Try to find a matching product by checking if any lookup key appears in the text
      var keys = Object.keys(vendorLookup);
      for (var i = 0; i < keys.length; i++) {
        if (text.toLowerCase().indexOf(keys[i].toLowerCase()) !== -1) {
          name = keys[i];
          break;
        }
      }
      // Fallback: use the full text as-is
      if (!name) name = text;
    }

    // Look up inspired-by from vendor lookup, strip "Inspired By" prefix
    var rawVendor = vendorLookup[name] || '';
    inspiredBy = rawVendor.replace(/^Inspired By\s*/i, '').trim();

    image = imageLookup[name] || '';

    return { name: name, inspiredBy: inspiredBy, image: image };
  }

  function isPlaceholder(option) {
    return option.disabled || option.value === '' ||
           option.text.trim().toLowerCase() === PLACEHOLDER_TEXT.toLowerCase();
  }

  function getProductForm() {
    return document.querySelector('form.product-purchase-form') ||
           document.querySelector('form[data-product-id]');
  }

  function getAddToCartButton() {
    var form = getProductForm();
    if (!form) return null;
    return form.querySelector('button[data-add-to-cart-text]') ||
           form.querySelector('button[type="submit"]') ||
           form.querySelector('.button');
  }

  // ============================================
  // DROPDOWN BUILDING
  // ============================================

  function buildDropdown(nativeSelect, index) {
    // Hide native select
    nativeSelect.style.display = 'none';

    // Sort options alphabetically by product title
    var options = Array.prototype.slice.call(nativeSelect.options);
    var regularOptions = options.filter(function(opt) { return !isPlaceholder(opt); });
    regularOptions.sort(function(a, b) {
      var nameA = parseOption(a.text).name.toLowerCase();
      var nameB = parseOption(b.text).name.toLowerCase();
      return nameA.localeCompare(nameB);
    });

    // Wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'bundle-dropdown';
    wrapper.dataset.index = index;

    // Selected display (trigger)
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'bundle-dropdown__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerImage = document.createElement('div');
    triggerImage.className = 'bundle-dropdown__trigger-image';
    triggerImage.innerHTML = '<div class="bundle-dropdown__placeholder-icon"></div>';

    var triggerText = document.createElement('div');
    triggerText.className = 'bundle-dropdown__trigger-text';
    triggerText.innerHTML = '<span class="bundle-dropdown__trigger-label">Selection ' + (index + 1) + '</span>' +
                            '<span class="bundle-dropdown__trigger-value">' + PLACEHOLDER_TEXT + '</span>';

    var triggerArrow = document.createElement('div');
    triggerArrow.className = 'bundle-dropdown__arrow';
    triggerArrow.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    trigger.appendChild(triggerImage);
    trigger.appendChild(triggerText);
    trigger.appendChild(triggerArrow);

    // Options panel
    var panel = document.createElement('div');
    panel.className = 'bundle-dropdown__panel';
    panel.setAttribute('role', 'listbox');

    // Search bar
    var searchWrap = document.createElement('div');
    searchWrap.className = 'bundle-dropdown__search';

    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'bundle-dropdown__search-input';
    searchInput.placeholder = 'Search...';
    searchInput.setAttribute('autocomplete', 'off');

    var searchClear = document.createElement('button');
    searchClear.type = 'button';
    searchClear.className = 'bundle-dropdown__search-clear';
    searchClear.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    searchClear.style.display = 'none';

    searchWrap.appendChild(searchInput);
    searchWrap.appendChild(searchClear);
    panel.appendChild(searchWrap);

    // Column headers
    var header = document.createElement('div');
    header.className = 'bundle-dropdown__header';
    header.innerHTML = '<span class="bundle-dropdown__col-name">Product</span>' +
                       '<span class="bundle-dropdown__col-vendor">Inspired by</span>';
    panel.appendChild(header);

    // Options list
    var list = document.createElement('div');
    list.className = 'bundle-dropdown__list';

    // No results message
    var noResults = document.createElement('div');
    noResults.className = 'bundle-dropdown__no-results';
    noResults.textContent = 'No results found';
    noResults.style.display = 'none';

    regularOptions.forEach(function(nativeOpt) {
      var data = parseOption(nativeOpt.text);

      var item = document.createElement('div');
      item.className = 'bundle-dropdown__option';
      item.setAttribute('role', 'option');
      item.dataset.value = nativeOpt.value;
      item.dataset.name = data.name;
      item.dataset.inspiredBy = data.inspiredBy;

      item.innerHTML = '<span class="bundle-dropdown__col-name">' + data.name + '</span>' +
                       '<span class="bundle-dropdown__col-vendor">' + data.inspiredBy + '</span>';

      list.appendChild(item);
    });

    list.appendChild(noResults);
    panel.appendChild(list);
    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);

    // Insert after native select
    nativeSelect.parentNode.insertBefore(wrapper, nativeSelect.nextSibling);

    // ---- Search wiring ----

    searchInput.addEventListener('input', function() {
      var query = searchInput.value.trim().toLowerCase();
      searchClear.style.display = query ? '' : 'none';

      var visibleCount = 0;
      list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
        var name = (el.dataset.name || '').toLowerCase();
        var inspiredBy = (el.dataset.inspiredBy || '').toLowerCase();
        var matches = !query || name.indexOf(query) !== -1 || inspiredBy.indexOf(query) !== -1;
        el.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      noResults.style.display = visibleCount === 0 ? '' : 'none';
    });

    searchClear.addEventListener('click', function(e) {
      e.stopPropagation();
      searchInput.value = '';
      searchClear.style.display = 'none';
      list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
        el.style.display = '';
      });
      noResults.style.display = 'none';
      searchInput.focus();
    });

    // Prevent clicks inside search from closing dropdown
    searchWrap.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    // ---- Toggle open/close ----

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var isOpen = wrapper.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        // Focus search and reset filter on open
        searchInput.value = '';
        searchClear.style.display = 'none';
        list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
          el.style.display = '';
        });
        noResults.style.display = 'none';
        setTimeout(function() { searchInput.focus(); }, 50);
      }
    });

    // ---- Option click → update native select + trigger display ----

    list.addEventListener('click', function(e) {
      var optionEl = e.target.closest('.bundle-dropdown__option');
      if (!optionEl) return;

      var value = optionEl.dataset.value;
      var name = optionEl.dataset.name;
      var inspiredBy = optionEl.dataset.inspiredBy;

      // Update native select
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      // Update trigger display
      var img = window.bundleImageLookup ? window.bundleImageLookup[name] : '';
      if (img) {
        triggerImage.innerHTML = '<img src="' + img + '" alt="' + name + '" />';
      }
      triggerText.innerHTML = '<span class="bundle-dropdown__trigger-label">' + name + '</span>' +
                              '<span class="bundle-dropdown__trigger-value">' + inspiredBy + '</span>';

      // Mark selected in list
      list.querySelectorAll('.bundle-dropdown__option').forEach(function(el) {
        el.classList.remove('is-selected');
      });
      optionEl.classList.add('is-selected');

      // Mark dropdown as having a user selection
      wrapper.classList.add('has-selection');
      wrapper.dataset.selectedTitle = name;

      // Close
      wrapper.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      // Update button states
      updateButtonState();
    });

    return wrapper;
  }

  // ============================================
  // OPEN/CLOSE MANAGEMENT
  // ============================================

  function closeAllDropdowns() {
    document.querySelectorAll('.bundle-dropdown.is-open').forEach(function(dd) {
      dd.classList.remove('is-open');
      dd.querySelector('.bundle-dropdown__trigger').setAttribute('aria-expanded', 'false');
    });
  }

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.bundle-dropdown')) {
      closeAllDropdowns();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  });

  // ============================================
  // BUTTON STATE MANAGEMENT (Phase 4)
  // ============================================

  // Check our custom UI, not the native selects (Simple Bundles pre-selects values underneath)
  function getUnselectedDropdowns() {
    var dropdowns = document.querySelectorAll('.bundle-dropdown');
    var missing = [];

    dropdowns.forEach(function(dd) {
      if (!dd.classList.contains('has-selection')) {
        var index = parseInt(dd.dataset.index, 10) + 1;
        missing.push('Selection ' + index);
      }
    });

    return missing;
  }

  function areAllOptionsSelected() {
    return getUnselectedDropdowns().length === 0;
  }

  function getUpsellAddButton() {
    return document.querySelector('.lb-spc-details-btn');
  }

  function updateButtonState() {
    if (!bundleReady) return;

    if (!addToCartButton) {
      addToCartButton = getAddToCartButton();
    }

    var upsellButton = getUpsellAddButton();
    var allSelected = areAllOptionsSelected();

    // Button stays enabled — modal handles validation on click
    if (addToCartButton) {
      addToCartButton.disabled = false;
    }

    if (upsellButton) {
      if (!upsellButton.dataset.bundleClickHandler) {
        upsellButton.dataset.bundleClickHandler = 'true';
        upsellButton.addEventListener('click', function(e) {
          if (!areAllOptionsSelected()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true);
      }

      if (allSelected) {
        upsellButton.style.pointerEvents = '';
        upsellButton.style.opacity = '';
      } else {
        upsellButton.style.pointerEvents = 'none';
        upsellButton.style.opacity = '0.5';
      }
    }
  }

  // ============================================
  // DUPLICATE DETECTION (Phase 4)
  // ============================================

  function getAllSelectedProducts() {
    var dropdowns = document.querySelectorAll('.bundle-dropdown.has-selection');
    var selected = [];

    dropdowns.forEach(function(dd) {
      if (dd.dataset.selectedTitle) {
        selected.push(dd.dataset.selectedTitle);
      }
    });

    return selected;
  }

  function areAllSelectionsTheSame(selections) {
    if (selections.length <= 1) return false;
    var first = selections[0];
    return selections.every(function(s) { return s === first; });
  }

  // Single modal — two modes: missing selections or duplicate warning
  function createBundleModal(options) {
    var existing = document.getElementById('bundle-modal');
    if (existing) existing.remove();

    var heading = options.heading;
    var body = options.body;
    var showProceed = options.showProceed || false;

    var modalHTML =
      '<div id="bundle-modal" style="display:flex;position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999;align-items:center;justify-content:center;">' +
        '<div class="bundle-modal__bg" style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);"></div>' +
        '<div class="bundle-modal__box" style="position:relative;z-index:2;background:#fff;padding:24px;border-radius:8px;max-width:440px;width:90%;">' +
          '<h3 style="margin:0 0 12px;">' + heading + '</h3>' +
          body +
          '<div style="display:flex;gap:10px;margin-top:20px;">' +
            '<button type="button" class="button bundle-modal__cancel" style="flex:1;">' + (showProceed ? 'Cancel' : 'OK') + '</button>' +
            (showProceed ? '<button type="button" class="button bundle-modal__proceed" style="flex:1;">Add to Cart</button>' : '') +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    var modal = document.getElementById('bundle-modal');

    return new Promise(function(resolve) {
      function close(confirmed) {
        modal.remove();
        document.removeEventListener('keydown', onKey);
        resolve(confirmed);
      }

      function onKey(e) {
        if (e.key === 'Escape') close(false);
      }

      modal.querySelector('.bundle-modal__bg').addEventListener('click', function() { close(false); });
      modal.querySelector('.bundle-modal__cancel').addEventListener('click', function() { close(false); });

      var proceedBtn = modal.querySelector('.bundle-modal__proceed');
      if (proceedBtn) {
        proceedBtn.addEventListener('click', function() { close(true); });
      }

      document.addEventListener('keydown', onKey);
    });
  }

  // ============================================
  // FORM SUBMISSION HANDLING (Phase 4)
  // ============================================

  function handleFormSubmit(event) {
    if (isManualSubmit) {
      isManualSubmit = false;
      return;
    }

    // 1. Check for missing selections (our UI is the source of truth)
    var missing = getUnselectedDropdowns();
    if (missing.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      createBundleModal({
        heading: 'Selections Required',
        body: '<p>Please make your choice for:</p><p><strong>' + missing.join(', ') + '</strong></p>',
        showProceed: false
      });

      return false;
    }

    // 2. Check for all-same duplicates
    var selectedProducts = getAllSelectedProducts();
    if (selectedProducts.length > 1 && areAllSelectionsTheSame(selectedProducts)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      createBundleModal({
        heading: 'Same Product Selected',
        body: '<p>You have selected <strong>' + selectedProducts.length + '</strong> of the same product: <strong>' + selectedProducts[0] + '</strong></p>' +
              '<p>Are you sure you want to continue?</p>',
        showProceed: true
      }).then(function(confirmed) {
        if (confirmed) {
          isManualSubmit = true;
          if (addToCartButton) {
            addToCartButton.click();
          } else {
            var form = getProductForm();
            if (form) form.submit();
          }
        }
      });

      return false;
    }
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function processBundleContainer() {
    var container = getBundleContainer();
    if (!container) return false;

    var selects = getBundleSelects();
    if (selects.length === 0) return false;

    // Don't double-process
    if (container.dataset.bundleUiProcessed === 'true') return true;
    container.dataset.bundleUiProcessed = 'true';

    bundleReady = true;

    selects.forEach(function(select, i) {
      buildDropdown(select, i);
    });

    updateButtonState();
    return true;
  }

  function init() {
    processBundleContainer();

    // Form submission handler for duplicate detection
    var form = getProductForm();
    if (form) {
      form.addEventListener('submit', handleFormSubmit, true);
    }

    // Watch for dynamically injected bundle content (Simple Bundles app)
    var observer = new MutationObserver(function(mutations) {
      var shouldProcess = false;
      var shouldUpdateButtons = false;

      mutations.forEach(function(mutation) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) return;

        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          if (node.id === BUNDLE_CONTAINER_ID ||
              (node.querySelector && node.querySelector('#' + BUNDLE_CONTAINER_ID))) {
            shouldProcess = true;
          }

          if (node.tagName === 'SELECT') {
            var cont = getBundleContainer();
            if (cont && cont.contains(node)) {
              shouldProcess = true;
            }
          }

          if ((node.classList && node.classList.contains('lb-spc-details-btn')) ||
              (node.querySelector && node.querySelector('.lb-spc-details-btn'))) {
            shouldUpdateButtons = true;
          }
        });
      });

      if (shouldProcess) {
        var cont = getBundleContainer();
        if (cont) cont.dataset.bundleUiProcessed = '';
        processBundleContainer();
      }

      if (shouldUpdateButtons) {
        updateButtonState();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
